var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-12"},[_c('p',{staticClass:"has-text-grey-light has-text-centered"},[_vm._v(" © "+_vm._s(_vm.$moment().format("YYYY"))+" "+_vm._s(_vm.hostname)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }